import { render, staticRenderFns } from "./EmployeeSurrenderRosterEdit.vue?vue&type=template&id=1190a767&scoped=true&"
import script from "./EmployeeSurrenderRosterEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeeSurrenderRosterEdit.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSurrenderRosterEdit.vue?vue&type=style&index=0&id=1190a767&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1190a767",
  null
  
)

export default component.exports